export default __webpack_public_path__ + "static/washer_w.f04a8199c062a8714eb8905644ad73b1.svg";